skrilla.directive('ethereumReceipts',function() {
    return {
        templateUrl: 'directives/ethereumReceipts/ethereumReceipts.html',
        scope: {},
        controller: function ($scope, searchService, cacheService, dateService, queryService, paginationService, srefService, envService) {
            $scope.getDate = dateService.getLocal;
            $scope.pageKey = "withdrawalReceipts";

            $scope.transfers = cacheService.getObjectOrElse($scope.pageKey, []);

            $scope.reset = function () {
                $scope.query = {
                    beforeDate: "",
                    afterDate: "",
                    limit: 20
                };
            }
            $scope.reset();

            $scope.getUri = function () {
                return envService.read('etherscanUrl');
            }

            $scope.search = function () {
                paginationService.resetPage($scope.pageKey);
                paginationService.pageQuery(receipts, $scope.pageKey);
            }

            var receipts = function () {
                return searchService.get("ethereum/receipts" + queryService.getQueryString($scope.query, $scope.pageKey)).then(function (response) {
                    $scope.transfers = response.data.result;
                    cacheService.registerObject($scope.pageKey, $scope.transfers);
                    paginationService.setPage($scope.pageKey, paginationService.buildPage(response));
                });
            }

            $scope.route = function(transfer){
                var location = "";
                switch(transfer.externalReferenceType){
                    case "WITHDRAWAL":
                        location = "withdrawalDetails";
                        break;
                    case "SALE":
                        location = "saleDetails";
                        break;
                    default:
                        location = "userDetails";
                        break;
                }
                srefService.go(location, {id: transfer.externalReferenceId});
            }


          $scope.getColour = function(transfer){
            switch(transfer.transactionStatus ){
              // case "0x1":
                // return "light-green";
              case "0x0":
                return "light-red";
              default :
                return null;
            }
          }
            $scope.goToUser = function (user) {
                if (user !== null) {
                    srefService.go("userDetails", {id: user.id});
                }
            }

            $scope.getUser = function (user, address) {
                var name = "";
                if (user === null) {
                } else {
                    name = user.username;
                }
                return name === "" ? name : " (" + name + ")";
            }
        }
    };
});